import { Injectable } from '@angular/core';
import { IToken } from './token.interface';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  getTokenBody() {
    const tokenEncoded = localStorage.getItem('token');
    return this.parseJwt(tokenEncoded);
  }

  setToken(tokenEncoded: string) {
    localStorage.setItem('token', tokenEncoded);
    const tokenDecoded = this.parseJwt(tokenEncoded);
    this.setCanSale(tokenDecoded.canSale);
  }

  setCanSale(canSale: boolean) {
    localStorage.setItem('canSale', canSale ? 'true' : 'false');
  }

  getCanSale() {
    const canSale = localStorage.getItem('canSale');
    return canSale === 'true';
  }

  isSeller() {
    const tokenEncoded = localStorage.getItem('token');
    const tokenDecoded = this.parseJwt(tokenEncoded);
    return tokenDecoded.roleId === 2;
  }

  isAdvanced() {
    const tokenEncoded = localStorage.getItem('token');
    const tokenDecoded = this.parseJwt(tokenEncoded);

    const isAdvanced = tokenDecoded.planBusinessId === 2;
    return isAdvanced;
  }

  isUser_change_password() {
    const tokenEncoded = localStorage.getItem('token');
    const tokenDecoded = this.parseJwt(tokenEncoded);
    const isUser_change_password = tokenDecoded.flag_change_password;
    return isUser_change_password;
  }

  getIdUser() {
    const tokenEncoded = localStorage.getItem('token');
    const tokenDecoded = this.parseJwt(tokenEncoded);
    return tokenDecoded.id;
  }

  getJWT() {
    const tokenEncoded = localStorage.getItem('token');
    const tokenDecoded = this.parseJwt(tokenEncoded);
    return tokenDecoded;
  }

  parseJwt(token: string): IToken {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }
}
